import React, { createContext, useContext, useEffect, useState } from 'react';
import { authService } from '../services/authService';

/**
 * --- KONTEKS OTENTIKASI (Pusat Keamanan) ---
 * File ini berfungsi sebagai "Ingatan Global" tentang siapa yang sedang login.
 * Dengan ini, semua halaman tahu apakah pengguna sudah masuk atau belum.
 */
const AuthContext = createContext();

export function AuthProvider({ children }) {
  // state: Memori untuk menyimpan data pengguna dan sesi aktif
  const [user, setUser] = useState(null);
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    /**
     * --- LOGIKA: Pengecekan Sesi Terakhir ---
     * Saat aplikasi pertama kali dibuka, kita cek apakah ada sesi login yang masih aktif.
     */
    const getInitialSession = async () => {
      const { session: initialSession, error } = await authService.getSession();
      if (!error && initialSession) {
        setSession(initialSession);
        setUser(initialSession.user);
      }
      setLoading(false);
    };

    getInitialSession();

    /**
     * --- LOGIKA: Mendengar Perubahan Status ---
     * Jika pengguna login atau logout di tengah jalan, fungsi ini akan otomatis
     * mengupdate data di seluruh aplikasi.
     */
    const subscription = authService.onAuthStateChange((_event, supabaseSession) => {
      setSession(supabaseSession);
      setUser(supabaseSession?.user ?? null);
      setLoading(false);
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  /**
   * --- FUNGSI-FUNGSI PEMBANTU (Aksi Otentikasi) ---
   * Fungsi-fungsi di bawah ini akan dipanggil oleh halaman Login atau Register.
   */
  const signUp = (email, password, metadata = {}) => authService.signUp(email, password, metadata);
  const signIn = (email, password) => authService.signIn(email, password);
  const signOut = () => authService.signOut();
  const resetPassword = (email) => authService.resetPassword(email);
  const updateProfile = (userId, full_name, store_name) => authService.updateProfile(userId, full_name, store_name);

  return (
    <AuthContext.Provider value={{ user, session, loading, signUp, signIn, signOut, resetPassword, updateProfile }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

// Hook kustom agar halaman lain mudah memanggil data user
export const useAuth = () => {
  return useContext(AuthContext);
};
